import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Stack, HStack, Button, useToast } from "@chakra-ui/react";
import {
  getLibrariesData,
  updateLibrariesData,
} from "../../../services/Libraries";

import Form from "@rjsf/chakra-ui";
import validator from "@rjsf/validator-ajv8";
import FormLoader from "../../../CommonComponents/FormLoader";
import { useSelector } from "react-redux";
import { handleApiError, showSuccessToast } from "../../../util/errorHandler";

const Keywords = () => {
  const { alias } = useParams();
  const [quickSave, setQuickSave] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [leftFormData, setLeftFormData] = useState({});
  const [rightFormData, setRightFormData] = useState({});
  const [combinedFormData, setCombinedFormData] = useState({});
  const previewEnabled = useSelector((state) => state.preview.isEnabled);
  const toast = useToast();
  const type = window.location.pathname.split("/")[1];

  // Split data for two-column layout
  const splitFormData = (data = {}) => {
    const leftFields = [
      "_id",
      "keywords",
      "keywords1_alias",
      "keywords2_alias",
      "keywords3_alias",
      "keywords4_alias",
      "keywords5_alias",
      "keywords6_alias",
      "keywords7_alias",
      "keywords8_alias",
      "keywords9_alias",
      "keywords10_alias",
      "keywords11_alias",
      "keywords12_alias",
      "keywords13_alias",
      "keywords14_alias",
      "other_keywords_alias",
      "other_keywords",
    ];
    const rightFields = [
      "precise_pagination_for_keyword1",
      "precise_pagination_for_keyword2",
      "precise_pagination_for_keyword3",
      "precise_pagination_for_keyword4",
      "precise_pagination_for_keyword5",
      "precise_pagination_for_keyword6",
      "precise_pagination_for_keyword7",
      "precise_pagination_for_keyword8",
      "precise_pagination_for_keyword9",
      "precise_pagination_for_keyword10",
      "precise_pagination_for_keyword11",
      "precise_pagination_for_keyword12",
      "precise_pagination_for_keyword13",
      "precise_pagination_for_keyword14",
      "essential_reading_for_keyword1",
      "essential_reading_for_keyword2",
      "essential_reading_for_keyword3",
      "essential_reading_for_keyword4",
      "essential_reading_for_keyword5",
      "essential_reading_for_keyword6",
      "essential_reading_for_keyword7",
      "essential_reading_for_keyword8",
      "essential_reading_for_keyword9",
      "essential_reading_for_keyword10",
      "suggested_reading_for_keyword1",
      "suggested_reading_for_keyword2",
      "suggested_reading_for_keyword3",
    ];

    const leftData = {};
    const rightData = {};

    leftFields.forEach((field) => {
      if (data.hasOwnProperty(field)) {
        leftData[field] = data[field];
      }
    });

    rightFields.forEach((field) => {
      if (data.hasOwnProperty(field)) {
        rightData[field] = data[field];
      }
    });

    return { leftData, rightData };
  };

  // Combine data from two forms
  const combineFormData = (leftData, rightData) => {
    return { ...leftData, ...rightData };
  };

  // Form change handlers
  const handleLeftFormChange = (data) => {
    setLeftFormData(data.formData);
  };

  const handleRightFormChange = (data) => {
    setRightFormData(data.formData);
  };

  const handleCombinedFormChange = (data) => {
    setCombinedFormData(data.formData);
  };

  // Left column schema
  const leftColumnSchema = {
    title: "",
    type: "object",
    properties: {
      _id: { type: "string" },
      keywords: {
        type: "array",
        items: {
          type: "string",
        },
        title: "Keywords",
      },
      keywords1_alias: {
        type: "string",
        title: "Keywords 1 alias",
      },
      keywords2_alias: {
        type: "string",
        title: "Keywords 2 alias",
      },
      keywords3_alias: {
        type: "string",
        title: "Keywords 3 alias",
      },
      keywords4_alias: {
        type: "string",
        title: "Keywords 4 alias",
      },
      keywords5_alias: {
        type: "string",
        title: "Keywords 5 alias",
      },
      keywords6_alias: {
        type: "string",
        title: "Keywords 6 alias",
      },
      keywords7_alias: {
        type: "string",
        title: "Keywords 7 alias",
      },
      keywords8_alias: {
        type: "string",
        title: "Keywords 8 alias",
      },
      keywords9_alias: {
        type: "string",
        title: "Keywords 9 alias",
      },
      keywords10_alias: {
        type: "string",
        title: "Keywords 10 alias",
      },
      keywords11_alias: {
        type: "string",
        title: "Keywords 11 alias",
      },
      keywords12_alias: {
        type: "string",
        title: "Keywords 12 alias",
      },
      keywords13_alias: {
        type: "string",
        title: "Keywords 13 alias",
      },
      keywords14_alias: {
        type: "string",
        title: "Keywords 14 alias",
      },
      other_keywords_alias: {
        type: "array",
        items: {
          type: "string",
        },
        title: "Other keywords alias",
      },
      other_keywords: {
        type: "string",
        title: "Other keywords",
      },
    },
  };

  // Right column schema
  const rightColumnSchema = {
    title: "",
    type: "object",
    properties: {
      precise_pagination_for_keyword1: {
        type: "string",
        title: "Precise pagination for keyword 1",
      },
      precise_pagination_for_keyword2: {
        type: "string",
        title: "Precise pagination for keyword 2",
      },
      precise_pagination_for_keyword3: {
        type: "string",
        title: "Precise pagination for keyword 3",
      },
      precise_pagination_for_keyword4: {
        type: "string",
        title: "Precise pagination for keyword 4",
      },
      precise_pagination_for_keyword5: {
        type: "string",
        title: "Precise pagination for keyword 5",
      },
      precise_pagination_for_keyword6: {
        type: "string",
        title: "Precise pagination for keyword 6",
      },
      precise_pagination_for_keyword7: {
        type: "string",
        title: "Precise pagination for keyword 7",
      },
      precise_pagination_for_keyword8: {
        type: "string",
        title: "Precise pagination for keyword 8",
      },
      precise_pagination_for_keyword9: {
        type: "string",
        title: "Precise pagination for keyword 9",
      },
      precise_pagination_for_keyword10: {
        type: "string",
        title: "Precise pagination for keyword 10",
      },
      precise_pagination_for_keyword11: {
        type: "string",
        title: "Precise pagination for keyword 11",
      },
      precise_pagination_for_keyword12: {
        type: "string",
        title: "Precise pagination for keyword 12",
      },
      precise_pagination_for_keyword13: {
        type: "string",
        title: "Precise pagination for keyword 13",
      },
      precise_pagination_for_keyword14: {
        type: "string",
        title: "Precise pagination for keyword 14",
      },
      essential_reading_for_keyword1: {
        type: "string",
        title: "Essential reading for keyword 1",
      },
      essential_reading_for_keyword2: {
        type: "string",
        title: "Essential reading for keyword 2",
      },
      essential_reading_for_keyword3: {
        type: "string",
        title: "Essential reading for keyword 3",
      },
      essential_reading_for_keyword4: {
        type: "string",
        title: "Essential reading for keyword 4",
      },
      essential_reading_for_keyword5: {
        type: "string",
        title: "Essential reading for keyword 5",
      },
      essential_reading_for_keyword6: {
        type: "string",
        title: "Essential reading for keyword 6",
      },
      essential_reading_for_keyword7: {
        type: "string",
        title: "Essential reading for keyword 7",
      },
      essential_reading_for_keyword8: {
        type: "string",
        title: "Essential reading for keyword 8",
      },
      essential_reading_for_keyword9: {
        type: "string",
        title: "Essential reading for keyword 9",
      },
      essential_reading_for_keyword10: {
        type: "string",
        title: "Essential reading for keyword 10",
      },
      suggested_reading_for_keyword1: {
        type: "string",
        title: "Suggested reading for keyword 1",
      },
      suggested_reading_for_keyword2: {
        type: "string",
        title: "Suggested reading for keyword 2",
      },
      suggested_reading_for_keyword3: {
        type: "string",
        title: "Suggested reading for keyword 3",
      },
    },
  };

  // Combined schema for preview mode
  const combinedSchema = {
    title: "",
    description: "",
    type: "object",
    properties: {
      _id: { type: "string" },
      keywords: {
        type: "array",
        items: {
          type: "string",
        },
        title: "Keywords",
      },
      keywords1_alias: {
        type: "string",
        title: "Keywords 1 alias",
      },
      keywords2_alias: {
        type: "string",
        title: "Keywords 2 alias",
      },
      keywords3_alias: {
        type: "string",
        title: "Keywords 3 alias",
      },
      keywords4_alias: {
        type: "string",
        title: "Keywords 4 alias",
      },
      keywords5_alias: {
        type: "string",
        title: "Keywords 5 alias",
      },
      keywords6_alias: {
        type: "string",
        title: "Keywords 6 alias",
      },
      keywords7_alias: {
        type: "string",
        title: "Keywords 7 alias",
      },
      keywords8_alias: {
        type: "string",
        title: "Keywords 8 alias",
      },
      keywords9_alias: {
        type: "string",
        title: "Keywords 9 alias",
      },
      keywords10_alias: {
        type: "string",
        title: "Keywords 10 alias",
      },
      keywords11_alias: {
        type: "string",
        title: "Keywords 11 alias",
      },
      keywords12_alias: {
        type: "string",
        title: "Keywords 12 alias",
      },
      keywords13_alias: {
        type: "string",
        title: "Keywords 13 alias",
      },
      keywords14_alias: {
        type: "string",
        title: "Keywords 14 alias",
      },
      other_keywords_alias: {
        type: "array",
        items: {
          type: "string",
        },
        title: "Other keywords alias",
      },
      precise_pagination_for_keyword1: {
        type: "string",
        title: "Precise pagination for keyword 1",
      },
      precise_pagination_for_keyword2: {
        type: "string",
        title: "Precise pagination for keyword 2",
      },
      precise_pagination_for_keyword3: {
        type: "string",
        title: "Precise pagination for keyword 3",
      },
      precise_pagination_for_keyword4: {
        type: "string",
        title: "Precise pagination for keyword 4",
      },
      precise_pagination_for_keyword5: {
        type: "string",
        title: "Precise pagination for keyword 5",
      },
      precise_pagination_for_keyword6: {
        type: "string",
        title: "Precise pagination for keyword 6",
      },
      precise_pagination_for_keyword7: {
        type: "string",
        title: "Precise pagination for keyword 7",
      },
      precise_pagination_for_keyword8: {
        type: "string",
        title: "Precise pagination for keyword 8",
      },
      precise_pagination_for_keyword9: {
        type: "string",
        title: "Precise pagination for keyword 9",
      },
      precise_pagination_for_keyword10: {
        type: "string",
        title: "Precise pagination for keyword 10",
      },
      precise_pagination_for_keyword11: {
        type: "string",
        title: "Precise pagination for keyword 11",
      },
      precise_pagination_for_keyword12: {
        type: "string",
        title: "Precise pagination for keyword 12",
      },
      precise_pagination_for_keyword13: {
        type: "string",
        title: "Precise pagination for keyword 13",
      },
      precise_pagination_for_keyword14: {
        type: "string",
        title: "Precise pagination for keyword 14",
      },
      essential_reading_for_keyword1: {
        type: "string",
        title: "Essential reading for keyword 1",
      },
      essential_reading_for_keyword2: {
        type: "string",
        title: "Essential reading for keyword 2",
      },
      essential_reading_for_keyword3: {
        type: "string",
        title: "Essential reading for keyword 3",
      },
      essential_reading_for_keyword4: {
        type: "string",
        title: "Essential reading for keyword 4",
      },
      essential_reading_for_keyword5: {
        type: "string",
        title: "Essential reading for keyword 5",
      },
      essential_reading_for_keyword6: {
        type: "string",
        title: "Essential reading for keyword 6",
      },
      essential_reading_for_keyword7: {
        type: "string",
        title: "Essential reading for keyword 7",
      },
      essential_reading_for_keyword8: {
        type: "string",
        title: "Essential reading for keyword 8",
      },
      essential_reading_for_keyword9: {
        type: "string",
        title: "Essential reading for keyword 9",
      },
      essential_reading_for_keyword10: {
        type: "string",
        title: "Essential reading for keyword 10",
      },
      suggested_reading_for_keyword1: {
        type: "string",
        title: "Suggested reading for keyword 1",
      },
      suggested_reading_for_keyword2: {
        type: "string",
        title: "Suggested reading for keyword 2",
      },
      suggested_reading_for_keyword3: {
        type: "string",
        title: "Suggested reading for keyword 3",
      },
      other_keywords: {
        type: "string",
        title: "Other keywords",
      },
    },
  };

  // Left column UI schema
  const leftColumnUiSchema = {
    "ui:submitButtonOptions": { norender: true },
    _id: { "ui:widget": "hidden" },
    "ui:style": {
      fontSize: "14px",
    },
    keywords: {
      "ui:readonly": true,
      "ui:options": {
        addable: false,
        removable: false,
        orderable: false,
      },
    },
    keywords1_alias: { "ui:emptyValue": "" },
    keywords2_alias: { "ui:emptyValue": "" },
    keywords3_alias: { "ui:emptyValue": "" },
    keywords4_alias: { "ui:emptyValue": "" },
    keywords5_alias: { "ui:emptyValue": "" },
    keywords6_alias: { "ui:emptyValue": "" },
    keywords7_alias: { "ui:emptyValue": "" },
    keywords8_alias: { "ui:emptyValue": "" },
    keywords9_alias: { "ui:emptyValue": "" },
    keywords10_alias: { "ui:emptyValue": "" },
    keywords11_alias: { "ui:emptyValue": "" },
    keywords12_alias: { "ui:emptyValue": "" },
    keywords13_alias: { "ui:emptyValue": "" },
    keywords14_alias: { "ui:emptyValue": "" },
    other_keywords: { "ui:widget": "hidden" },
  };

  // Right column UI schema
  const rightColumnUiSchema = {
    "ui:submitButtonOptions": { norender: true },
    "ui:style": {
      fontSize: "14px",
    },
    precise_pagination_for_keyword1: { "ui:emptyValue": "" },
    precise_pagination_for_keyword2: { "ui:emptyValue": "" },
    precise_pagination_for_keyword3: { "ui:emptyValue": "" },
    precise_pagination_for_keyword4: { "ui:emptyValue": "" },
    precise_pagination_for_keyword5: { "ui:emptyValue": "" },
    precise_pagination_for_keyword6: { "ui:emptyValue": "" },
    precise_pagination_for_keyword7: { "ui:emptyValue": "" },
    precise_pagination_for_keyword8: { "ui:emptyValue": "" },
    precise_pagination_for_keyword9: { "ui:emptyValue": "" },
    precise_pagination_for_keyword10: { "ui:emptyValue": "" },
    precise_pagination_for_keyword11: { "ui:emptyValue": "" },
    precise_pagination_for_keyword12: { "ui:emptyValue": "" },
    precise_pagination_for_keyword13: { "ui:emptyValue": "" },
    precise_pagination_for_keyword14: { "ui:emptyValue": "" },
    essential_reading_for_keyword1: { "ui:emptyValue": "" },
    essential_reading_for_keyword2: { "ui:emptyValue": "" },
    essential_reading_for_keyword3: { "ui:emptyValue": "" },
    essential_reading_for_keyword4: { "ui:emptyValue": "" },
    essential_reading_for_keyword5: { "ui:emptyValue": "" },
    essential_reading_for_keyword6: { "ui:emptyValue": "" },
    essential_reading_for_keyword7: { "ui:emptyValue": "" },
    essential_reading_for_keyword8: { "ui:emptyValue": "" },
    essential_reading_for_keyword9: { "ui:emptyValue": "" },
    essential_reading_for_keyword10: { "ui:emptyValue": "" },
    suggested_reading_for_keyword1: { "ui:emptyValue": "" },
    suggested_reading_for_keyword2: { "ui:emptyValue": "" },
    suggested_reading_for_keyword3: { "ui:emptyValue": "" },
  };

  // Combined UI schema for preview mode
  const combinedUiSchema = {
    "ui:submitButtonOptions": { norender: true },
    _id: { "ui:widget": "hidden" },
    "ui:style": {
      fontSize: "14px",
    },
    keywords: {
      "ui:readonly": true,
      "ui:options": {
        addable: false,
        removable: false,
        orderable: false,
      },
    },
    keywords1_alias: { "ui:emptyValue": "" },
    keywords2_alias: { "ui:emptyValue": "" },
    keywords3_alias: { "ui:emptyValue": "" },
    keywords4_alias: { "ui:emptyValue": "" },
    keywords5_alias: { "ui:emptyValue": "" },
    keywords6_alias: { "ui:emptyValue": "" },
    keywords7_alias: { "ui:emptyValue": "" },
    keywords8_alias: { "ui:emptyValue": "" },
    keywords9_alias: { "ui:emptyValue": "" },
    keywords10_alias: { "ui:emptyValue": "" },
    keywords11_alias: { "ui:emptyValue": "" },
    keywords12_alias: { "ui:emptyValue": "" },
    keywords13_alias: { "ui:emptyValue": "" },
    keywords14_alias: { "ui:emptyValue": "" },
    other_keywords: { "ui:widget": "hidden" },
    precise_pagination_for_keyword1: { "ui:emptyValue": "" },
    precise_pagination_for_keyword2: { "ui:emptyValue": "" },
    precise_pagination_for_keyword3: { "ui:emptyValue": "" },
    precise_pagination_for_keyword4: { "ui:emptyValue": "" },
    precise_pagination_for_keyword5: { "ui:emptyValue": "" },
    precise_pagination_for_keyword6: { "ui:emptyValue": "" },
    precise_pagination_for_keyword7: { "ui:emptyValue": "" },
    precise_pagination_for_keyword8: { "ui:emptyValue": "" },
    precise_pagination_for_keyword9: { "ui:emptyValue": "" },
    precise_pagination_for_keyword10: { "ui:emptyValue": "" },
    precise_pagination_for_keyword11: { "ui:emptyValue": "" },
    precise_pagination_for_keyword12: { "ui:emptyValue": "" },
    precise_pagination_for_keyword13: { "ui:emptyValue": "" },
    precise_pagination_for_keyword14: { "ui:emptyValue": "" },
    essential_reading_for_keyword1: { "ui:emptyValue": "" },
    essential_reading_for_keyword2: { "ui:emptyValue": "" },
    essential_reading_for_keyword3: { "ui:emptyValue": "" },
    essential_reading_for_keyword4: { "ui:emptyValue": "" },
    essential_reading_for_keyword5: { "ui:emptyValue": "" },
    essential_reading_for_keyword6: { "ui:emptyValue": "" },
    essential_reading_for_keyword7: { "ui:emptyValue": "" },
    essential_reading_for_keyword8: { "ui:emptyValue": "" },
    essential_reading_for_keyword9: { "ui:emptyValue": "" },
    essential_reading_for_keyword10: { "ui:emptyValue": "" },
    suggested_reading_for_keyword1: { "ui:emptyValue": "" },
    suggested_reading_for_keyword2: { "ui:emptyValue": "" },
    suggested_reading_for_keyword3: { "ui:emptyValue": "" },
  };

  // Fetch initial data
  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getLibrariesData(alias, "keywords", type);
          if (result) {
            const data = result?.data?.[0];
            // Split data for two-column layout
            const { leftData, rightData } = splitFormData(data);
            setLeftFormData(leftData);
            setRightFormData(rightData);
            setCombinedFormData(data);
            setQuickSave(false);
          }
        } else {
          // For new records, initialize empty forms
          const emptyData = {};
          const { leftData, rightData } = splitFormData(emptyData);
          setLeftFormData(leftData);
          setRightFormData(rightData);
          setCombinedFormData(emptyData);
        }
      } catch (error) {
        handleApiError(error, toast, {
          defaultErrorMessage: "Failed to fetch data",
        });
      } finally {
        setIsLoading(false);
      }
    };

    getBasicData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alias, toast, quickSave]);

  // Submit updated data
  const handleSubmit = async () => {
    setIsSubmitting(true);

    try {
      let finalFormData;

      if (previewEnabled) {
        finalFormData = combinedFormData;
      } else {
        finalFormData = combineFormData(leftFormData, rightFormData);
      }

      // Remove _id from create operations
      if (!alias && finalFormData._id) {
        delete finalFormData._id;
      }

      if (alias) {
        const result = await updateLibrariesData(
          alias,
          finalFormData,
          "",
          "keywords",
        );

        if (result?.status === 200) {
          setQuickSave((prev) => !prev);
          showSuccessToast(toast, "Data updated successfully");
        }
      }
    } catch (error) {
      handleApiError(error, toast, {
        defaultErrorMessage: "Failed to update data",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box maxW="auto" pb="100px">
      {isLoading ? (
        <FormLoader />
      ) : (
        <Box>
          {previewEnabled ? (
            /* Single column layout for preview mode */
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"flex-start"}
            >
              <Box
                flex={1}
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                p={4}
                borderRadius="md"
              >
                <Box fontSize="lg" fontWeight="bold" mb={4}>
                  Keywords Fields
                </Box>
                <Form
                  schema={combinedSchema}
                  uiSchema={combinedUiSchema}
                  formData={combinedFormData}
                  validator={validator}
                  onChange={handleCombinedFormChange}
                  fontsize={"14px"}
                />
              </Box>
            </Box>
          ) : (
            /* Two column layout with separate forms */
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"flex-start"}
            >
              <Stack
                flexDirection="row"
                gap={4}
                alignItems="flex-start"
                flex={1}
              >
                <HStack alignItems="flex-start" flex={1}>
                  {/* Left Column */}
                  <Box
                    flex={1}
                    bg="white"
                    border="1px solid"
                    borderColor="gray.200"
                    p={4}
                    borderRadius="md"
                  >
                    <Box fontSize="lg" fontWeight="bold" mb={4}>
                      Keywords Fields
                    </Box>
                    <Form
                      schema={leftColumnSchema}
                      uiSchema={leftColumnUiSchema}
                      formData={leftFormData}
                      validator={validator}
                      onChange={handleLeftFormChange}
                      fontsize={"14px"}
                    />
                  </Box>
                  {/* Right Column */}
                  <Box
                    flex={1}
                    bg="white"
                    border="1px solid"
                    borderColor="gray.200"
                    p={4}
                    borderRadius="md"
                  >
                    <Form
                      schema={rightColumnSchema}
                      uiSchema={rightColumnUiSchema}
                      formData={rightFormData}
                      validator={validator}
                      onChange={handleRightFormChange}
                      fontsize={"14px"}
                    />
                  </Box>
                </HStack>
              </Stack>
            </Box>
          )}
        </Box>
      )}

      {/* Fixed Save Button */}
      <Box
        position="fixed"
        bottom={0}
        left={"250px"}
        right={0}
        bg="white"
        borderTop="1px solid"
        borderColor="gray.200"
        p={4}
        zIndex={1000}
      >
        <Box maxW="auto" mx="auto" display="flex" justifyContent="center">
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={isSubmitting}
            width="auto"
            margin="0 auto"
            textAlign="center"
          >
            {isSubmitting ? "Saving..." : "Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Keywords;
